import React, { useRef } from 'react';
import styled, { css } from 'styled-components';
import { Table } from '../Table/Table';
import { useScrolledToRight } from '../hooks';
import { themeColor } from '../theme/colors';

const SHADOW_WIDTH = '55px';

export interface HorizontalContainerProps extends React.PropsWithChildren {
  withShadow?: boolean;
  withShadowPadding?: boolean;
}

export function HorizontalContainer({
  children,
  withShadow = true,
  ...rest
}: HorizontalContainerProps) {
  const scrollableRef = useRef<HTMLDivElement>(null);
  const isScrolled = useScrolledToRight(scrollableRef);

  return (
    <Container {...rest}>
      {withShadow && <Shadow $visible={!isScrolled} />}
      <Scrollable ref={scrollableRef}>{children}</Scrollable>
    </Container>
  );
}

const Container = styled.div`
  position: relative;
  overflow-x: hidden;
  display: flex;
`;

const Scrollable = styled.div`
  box-sizing: content-box;
  width: 100%;
  height: 100%;
  overflow-x: auto;
  flex: 1;
  display: block;

  ${Table} {
    width: 100%;
  }
`;

export const Shadow = styled.div<{ $visible: boolean }>`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: ${SHADOW_WIDTH};
  background: ${themeColor('tableGradient')};
  /* This make sure shadow div is 'transparent' to pointer events */
  pointer-events: none;
  z-index: 99;

  transition: opacity 0.4s ease-in-out;
  ${(props) =>
    !props.$visible &&
    css`
      opacity: 0;
    `}
`;
